import React, { Component } from 'react';
import PropTypes from 'prop-types';
import Head from 'next/head';
import compose from 'lodash.compose';
import Page from '../components/printable';
import attachI18n from '../components/hoc/attach-i18n';
import withErrors from '../components/hoc/with-errors';
import Applications from '../components/product/applications';
import Crc from '../components/product/crc';
import Kits from '../components/product/kits';
import ProductDetails from '../components/product/product-details';
import Error from './_error';

class Product extends Component {
  componentDidMount() {
    setTimeout(() => window.print(), 500); // Allows some time before show print
  }
  render() {
    let { product, applications, crc, kits, t, tReady, i18n: { language } } = this.props;
    if (!product) {
      return <Error code={404}/>;
    }
    return (
      <Page ready={tReady}>
        {() => (
          <>
            <Head>
              <title>{t(`types.${product.type}`)} - {product.code}</title>
              <meta name="description" content={product[`description_${language}`]}/>
            </Head>
            <div>
              <section id="data-sheet">
                <h1>{t(`types.${product.type}`)} - {product.code}</h1>
                <h3>
                  {product[`description_${language}`]}
                </h3>
                {/*FOTO + DETTAGLI*/}
                <div className="row">
                  <div className="3u -1u 12u(small)">
                    <span className="image fit">
                      <img src={product.image || '/static/images/default-kit.jpg'} alt=""/>
                    </span>
                  </div>
                  <div className="7u -1u 12u(small)">
                    <ProductDetails product={product}/>
                  </div>
                </div>
                {/*KITS*/}
                <div className="row">
                  <div className="12u">
                    {kits && (<Kits kits={kits} isOpened/>)}
                  </div>
                </div>
                {/*APPLICAZIONI*/}
                <div className="row">
                  <div className="12u">
                    {applications && (<Applications applications={applications} isOpened/>)}
                  </div>
                </div>
                {/*CRC*/}
                <div className="row">
                  <div className="12u">
                    {crc && (<Crc crc={crc} isOpened/>)}
                  </div>
                </div>
              </section>
            </div>
          </>
        )}
      </Page>
    );
  }
}

Product.defaultProps = {};
Product.propTypes = {
  product: PropTypes.shape({
    _id: PropTypes.string.isRequired,
    type: PropTypes.oneOf(['Kit', 'TorsionDamper', 'DrivenPlate', 'PressurePlate', 'Bearing']),
  }),
  kits: PropTypes.arrayOf(PropTypes.object),
  applications: PropTypes.arrayOf(PropTypes.object),
  crc: PropTypes.arrayOf(PropTypes.object),
};
Product.getInitialProps = async ({ req }) => {
  const { slug, id } = req.params;
  const result = await fetch(`${process.env.API_HOST}/api/v1/catalogue/product/${slug}/${id}`);
  const { product, applications, kits, crc } = await result.json();
  if (!product) {
    res.statusCode = 404;
  }
  return { product, applications, kits, crc };
};

export default compose(
  attachI18n('product'),
  withErrors
)(Product);
